import { AntModalProps, ModalPosition } from 'controls/react/ant/antModal';

export enum LogEntryStatus {
	Ok = 'OK',
	Error = 'ERROR',
	Warning = 'WARNING',
	Failed = 'FAILED',
	Unknown = 'UNKNOWN',
}

export type LogEntryModel = {
	status: LogEntryStatus;
	message: string;
};

export type LogEntryFormConfig = {
	serviceId: string;
	positionType?: ModalPosition;
	positionAnchor?: AntModalProps['positionAnchor'];
	onSave?: () => void;
	onCancel?: () => void;
};
